module.exports = __webpack_public_path__ + "img/tg_01 (7).fb7d0e49.jpg";